export const KEYCLOAK_CLIENT_ID = "accello360-frontend";
export const KEYCLOAK_DEFAULT_REALM = "master";
export const KEYCLOAK_ON_LOAD: "check-sso" = "check-sso";
export const KEYCLOAK_CHECK_LOGIN_IFRAME = false;
